import { render, staticRenderFns } from "./advisors.vue?vue&type=template&id=0853c4db"
import script from "./advisors.vue?vue&type=script&lang=js"
export * from "./advisors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports